import segoeImage from "../../../../src/images/segoe.svg";
import sfImage from "../../../../src/images/sf.svg";
import sfMonoImage from "../../../../src/images/sfMono.svg";
import interImage from "../../../../src/images/interUI.svg";
import ubuntuImage from "../../../../src/images/ubuntu.svg";
import * as React from 'react';
export default {
  segoeImage,
  sfImage,
  sfMonoImage,
  interImage,
  ubuntuImage,
  React
};